import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  flex: {
    display: "flex",
  },
  flexWrap: {
    flexWrap: "wrap",
  },
  flexCol: {
    flexDirection: "column",
  },
  spaceBw: {
    justifyContent: "space-between",
  },
  justifyCenter: {
    justifyContent: "center",
  },
  justifyEnd: {
    justifyContent: "end",
  },
  alignCenter: {
    alignItems: "center",
  },
  alignStart: {
    alignItems: "start",
  },
  alignEnd: {
    alignItems: "end",
  },
  textCenter: {
    textAlign: "center",
  },
  // list venue css

  // web view new css

  ctaTwo: {
    fontWeight: "700",
    fontSize: "18px",
    color: "#fff",
    lineHeight: "18px",
    letterSpacing: "0.4px",
    backgroundColor: "#ff4e00",
    padding: "12px 24px",
    borderRadius: "20px",
  },
  carouselArea: {
    "& .control-dots": {
      margin: "8px 0 !important",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      display: "none !important",
      "& li": {
        background: "#000 !important",
        opacity: "1 !important",
        outline: "none",
        boxShadow: "none !important",
        height: "6px !important",
        width: "6px !important",
        margin: "0 3px !important",
        display: "none !important",
      },
      "& li.selected": {
        background: "#000 !important",
        height: "6px !important",
        width: "24px !important",
        borderRadius: "10px",
        display: "none !important",
      },
    },
  },
  carouselBannerDiv: {
    display: "block",
    width: "100%",
    backgroundColor: "#e6a71e",
    padding: "16px",
  },
  carouselContainer: {
    overflowX: "auto",
    scrollSnapType: "x mandatory",
    scrollBehavior: "smooth",
    WebkitOverflowScrolling: "touch",
    width: "100%",
    maxWidth: "520px",
    marginLeft: "16px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  carouselTrack: {
    display: "flex",
    gap: "20px",
    scrollSnapType: "x mandatory",
  },
  pickleCard: {
    flex: "0 0 80%",
    backgroundColor: "white",
    scrollSnapAlign: "start",
    borderRadius: "20px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    border: "2px solid #f2500b",
    cursor: "default",
  },
  reviewCard: {
    flex: "0 0 35%",
    marginRight: "24px",
    "@media (max-width: 1250px)": {
      flex: "0 0 45%",
    },
  },
  cardHeader: {
    backgroundColor: "#f2500b",
    padding: "16px 20px",
    borderTopLeftRadius: "18px",
    borderTopRightRadius: "18px",
  },
  cardTopText: {
    margin: 0,
    fontSize: "22px",
    fontWeight: "bold",
    color: "#fff",
  },
  cardParaText: {
    margin: "4px 0 0",
    fontSize: "16px",
    color: "#fff",
  },
  cardBody: {
    padding: "20px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#333",
    fontWeight: "500",
  },
  carouselDots: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    margin: "24px 0px",
  },
  dot: {
    width: "10px",
    height: "10px",
    backgroundColor: "#ccc",
    borderRadius: "50%",
    transition: "background-color 0.3s ease",
  },
  activeDot: {
    backgroundColor: "#ff4e00",
  },
  w100: {
    width: "100%",
  },
  mT16: {
    marginTop: "16px",
  },
  hrLine: {
    backgroundColor: "#424242",
    height: "1px",
  },
  mainContainer: {
    // maxWidth: "550px",
    position: "relative",
  },
  kmImage: {
    // width: "112px",
    height: "38px",
    verticalAlign: "middle",
    objectFit: "contain",
  },
  downShadow: {
    width: "100%",
    position: "sticky",
    top: "0px",
    backgroundColor: "#fff",
    zIndex: "99999",
    padding: "48px 120px 16px 120px",
  },
  verLine: {
    width: "36px",
    rotate: "90deg",
    border: "1px solid #ff4e00",
  },
  acrossCity: {
    fontSize: "22px",
    lineHeight: "28px",
    fontWeight: "700",
    color: "#424242",
    letterSpacing: "0.25px",
  },
  scrollCard: {
    display: "flex",
    overflowX: "auto",
    scrollBehavior: "smooth",
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    // paddingBottom: "16px",
  },
  shadowCard: {
    boxShadow: "4px 4px 4.3px 0px #3131313B",
    width: "210px",
    borderRadius: "16px",
    padding: "16px",
    flexShrink: 0,
    marginRight: "24px",
  },
  flexContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
    padding: "32px 0",
  },

  topRow: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "24px",
    width: "100%",
  },
  bottomRow: {
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    width: "100%",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    padding: "24px",
    textAlign: "center",
    maxWidth: "360px",
    flex: "1 1 210px",
  },
  cardHeading: {
    fontSize: "20px",
    color: "#ff4e00",
    lineHeight: "24px",
    letterSpacing: "0.25px",
    fontWeight: "700",
    marginBottom: "12px",
  },
  cardPara: {
    fontSize: "18px",
    color: "#424242",
    lineHeight: "26px",
    letterSpacing: "0.1px",
    fontWeight: "400",
  },
  topHeading: {
    fontSize: "32px",
    color: "#424242",
    lineHeight: "38px",
    letterSpacing: "0.25px",
    fontWeight: "700",
    display: "inline-block",
    // fontFamily: "Roboto",
  },
  talkText: {
    fontSize: 20,
    lineHeight: "28px",
  },
  callCta: {
    backgroundColor: "#fff",
    border: "1px solid #ff4e00",
    color: "#424242",
  },
  carouselText: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "18px",
    color: "#000",
    letterSpacing: "0.1px",
  },
  topText: {
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "26px",
    fontWeight: "700",
    lineHeight: "30px",
  },
  form: {
    maxWidth: "550px",
  },
  orangeBg: {
    background: "#FF4E00",
  },
  disabled: {
    background: "#BDBDBD",
    cursor: "initial",
  },
  doneIcon: {
    " & svg": {
      width: "28px",
      height: "28px",
      "& path": {
        fill: "green",
      },
    },
  },
  participantInput: {
    display: "flex",
    width: "100%",
    fontWeight: 600,
    fontSize: 15,
    height: "36px",
    padding: "16px",
    alignItems: "center",
    flexShrink: 0,
    borderRadius: "15px",
    outline: "none",
    // borderBottom: "1px solid rgba(255, 78, 0, 0.6)",
    borderBottom: "1px solid #424242",
    border: "none",
    margin: "16px auto",
    color: "#333",
    borderRadius: "inherit",
    "&::placeholder": {
      color: "#ff4e00",
      fontWeight: 700,
      fontSize: 14,
    },
  },
  finalBox2: {
    height: "72px",
    background: "#FFF",
    display: "flex",
    alignItems: "center",
  },
  finalBtn2: {
    // width: "100%",
    borderRadius: "12px",
    background: "#FF4E00",
  },
  finalButton2: {
    display: "block",
    // width: "100%",
    height: "48px",
    padding: "16px 76px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "12px",
    fontWeight: "700",
    color: "white",
    fontSize: "15px",
    lineHeight: "16px",
  },
  topTextTwo: {
    color: "#ccc",
    fontSize: "16px !important",
  },
  drawerAutoHeight2: {
    height: "auto !important",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  drawerBodyHeight2: {
    height: "auto !important",
    overflow: "hidden",
  },
  faqDetail: {
    // margin: "16px",
  },
  mB0: {
    marginBottom: "0px",
  },
  mb16: {
    marginBottom: "16px",
  },
  mB10: {
    marginBottom: "10px",
  },
  mT40: {
    marginTop: "40px",
  },
  mB40: {
    marginBottom: "40px",
  },
  pB0: {
    paddingBottom: 0,
  },
  faq: {
    marginBottom: "2px",
  },
  seeAll: {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    bottom: "-6px",
    cursor: "pointer",
    "& svg": {
      width: "18px",
      height: "18px",
      "& path": {
        fill: "#ccc",
      },
    },
  },
  rotate: {
    rotate: "180deg",
  },
  mbZero: {
    marginBottom: 0,
  },
  faqHead: {
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.25px",
    color: "#ff4e00",
    marginBottom: "8px",
  },
  faqPara: {
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "28px",
    color: "#424242",
  },
  circle: {
    display: "inline-block",
    width: "34px",
    height: "34px",
    backgroundColor: "#424242",
    borderRadius: "50%",
    margin: "0 auto",
    position: "absolute",
    bottom: 16,
    cursor: "pointer",
  },
  faqLine: {
    width: 118,
    margin: "8px 0px",
  },
  innerBtn: {
    fontSize: "20px",
    fontWeight: "700",
    padding: "15px 30px",
  },
  cross: {
    position: "relative",
    top: "-10px",
    right: "-20px",
  },
  call: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "12px",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    color: "#19A3FF",
  },
  areaHeight: {
    height: 64,
  },
  listStyle: {
    listStyle: "disc",
    marginLeft: "24px",
  },
  faqList: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "0px",
    listStyleType: "none",
    padding: 0,
    margin: 0,
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
  eventImg: {
    width: "100%",
    height: "620px",
    objectFit: "contain",
  },
  eventOne: {
    position: "relative",
    right: "20%",
  },
  eventTwo: {
    position: "relative",
    left: "30%",
    bottom: "10px",
  },
  eventThree: {
    position: "relative",
    right: "10%",
    marginTop: "24px",
  },
  eventFour: {
    position: "relative",
    right: "-5%",
    marginTop: "24px",
  },
  eventFive: {
    position: "relative",
    right: "15%",
  },
  eventSix: {
    position: "relative",
    right: "-10%",
  },
  evText: {
    fontSize: "32px !important",
    lineHeight: "38px",
    color: "#ff4e00",
    fontWeight: "700",
    letterSpacing: "0.2px",
  },
  evOne: {
    position: "relative",
    left: "60%",
    top: "-50px",
  },
  evTwo: {
    position: "relative",
    right: "55%",
    top: "-60px",
  },
  handle: {
    fontSize: "20px",
    lineHeight: "28px",
    fontWeight: "500",
    color: "#424242",
    letterSpacing: "0.1px",
    // whiteSpace: "nowrap",
  },
  evThree: {
    position: "relative",
    left: "70%",
    top: "-60px",
  },
  evFour: {
    position: "relative",
    left: "30%",
    top: "-90px",
  },
  evFive: {
    position: "relative",
    left: "70%",
    top: "-40px",
  },
  evSix: {
    position: "relative",
    left: "25%",
    top: "-30px",
  },
  leftAlignOne: {
    position: "relative",
    left: "0%",
  },
  leftAlignTwo: {
    position: "relative",
  },
  // gcss
  featureContainer: {
    display: "flex",
    flexDirection: "column",
    // gap: "140px", // slightly larger vertical gap for desktop
    // padding: "100px 0",
    width: "100%",
  },

  featureRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    // gap: "80px",
    minHeight: "460px", // consistent height for large screens

    "@media (max-width: 1400px)": {
      // gap: "70px",
      minHeight: "460px",
    },
    "@media (max-width: 1200px)": {
      // gap: "50px",
      minHeight: "460px",
    },
    "@media (max-width: 992px)": {
      // gap: "30px",
      minHeight: "380px",
    },
    "@media (max-width: 768px)": {
      flexDirection: "column",
      textAlign: "center",
      // gap: "40px",
      minHeight: "auto",
    },
  },

  reverse: {
    flexDirection: "row-reverse",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },

  featureImage: {
    flex: "1 1 100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& img": {
      width: "100%",
      height: "auto",
      marginBottom: "24px",
      objectFit: "contain",
      borderRadius: "8px",
      display: "block",
      aspectRatio: "22/16", // ensures image height scales consistently with width
    },
    "@media (max-width: 992px)": {
      flex: "1 1 100%",
    },
  },

  featureText: {
    flex: "1 1 40%",
    maxWidth: "520px",
    position: "relative",
    top: "-80px",
    "@media (max-width: 1400px)": {
      maxWidth: "480px",
    },
    "@media (max-width: 1200px)": {
      // maxWidth: "220px",
    },
    "@media (max-width: 992px)": {
      maxWidth: "360px",
    },
    "@media (max-width: 768px)": {
      maxWidth: "90%",
    },
    "& h3": {
      color: "#ff5c00",
      fontSize: "32px",
      fontWeight: 700,
      marginBottom: "12px",
      lineHeight: "38px",
      "@media (max-width: 1200px)": {
        fontSize: "24px",
        lineHeight: "30px",
      },
    },
    "& p": {
      color: "#212121",
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: 500,
      "@media (max-width: 1200px)": {
        fontSize: "22px",
        lineHeight: "28px",
      },
    },
  },

  textLeftOffset: {
    position: "relative",
    left: "-10%",
  },

  textRightOffset: {
    position: "relative",
    right: "-10%",
  },

  // gcss end
  formContainer: {
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    borderRadius: "32px",
    padding: "48px 24px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)", // 2 columns
    gap: "24px 32px", // vertical & horizontal spacing between inputs
    width: "100%",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr", // stack inputs on mobile
    },
  },

  "@media (max-width: 550px)": {
    margin0: {
      margin: "0px",
    },
    acrossCity: {
      fontSize: "14px",
    },
    hrLine: {
      margin: "0px 16px 16px 16px",
    },
    cardHeading: {
      fontSize: "16px",
      lineHeight: "24px",
    },
    cardPara: {
      fontSize: "14px",
      lineHeight: "22px",
    },
    ctaTwo: {
      padding: "8px 12px",
      fontSize: "14px",
    },
    drawerAutoHeight2: {
      height: "auto !important",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
    },
    drawerBodyHeight2: {
      height: "auto !important",
    },
    carouselContainer: {
      maxWidth: "376px",
      marginLeft: "0px",
    },
    topHeading: {
      fontSize: "16px",
      lineHeight: "22px",
      // marginBottom:"16px"
    },
    fs15: {
      fontSize: "15px",
    },
    evText: {
      fontSize: "16px !important",
      lineHeight: "20px",
    },
    handle: {
      fontSize: "14px",
      lineHeight: "20px",
    },
    eventTwo: {
      bottom: "5px",
    },
    evOne: {
      left: "60%",
    },
    evTwo: {
      right: "60%",
      top: "-25px",
    },
    evThree: {
      top: "-42px",
      left: "58%",
    },
    evFour: {
      top: "-58px",
      left: "20%",
    },
    evFive: {
      top: "-20px",
      left: "58%",
    },
    evSix: {
      top: "0px",
      left: "20%",
    },
    downShadow: {
      boxShadow: "4px 4px 23.1px 0px #84848440",
      padding: "16px",
    },
    eventImg: {
      width: "70%",
      height: "auto",
    },
    eventThree: {
      right: "25%",
    },
    eventFour: {
      right: "5%",
    },
    eventFive: {
      right: "35%",
    },
    eventSix: {
      right: "0%",
    },
    cardTopText: {
      fontSize: "18px",
    },
    cardParaText: {
      fontSize: "14px",
    },
    cardBody: {
      fontSize: "14px",
    },
    talkText: {
      fontSize: "16px",
    },
    participantInput: {
      display: "flex",
      width: "90%",
      fontWeight: 600,
      fontSize: 15,
      height: "36px",
      padding: "16px",
      alignItems: "center",
      flexShrink: 0,
      borderRadius: "15px",
      outline: "none",
      // borderBottom: "1px solid rgba(255, 78, 0, 0.6)",
      borderBottom: "1px solid #424242",
      border: "none",
      margin: "16px auto",
      color: "#333",
      borderRadius: "inherit",
      "&::placeholder": {
        color: "#ff4e00",
        fontWeight: 700,
        fontSize: 14,
      },
    },
    finalBox2: {
      width: "100%",
      justifyContent: "center",
      padding: "15px 16px",
    },
    finalBtn2: {
      width: "100%",
      borderRadius: "12px",
      background: "#FF4E00",
    },
    finalButton2: {
      display: "block",
      width: "100%",
      height: "48px",
      padding: "16px 76px",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      borderRadius: "12px",
      fontWeight: "700",
      color: "white",
      fontSize: "15px",
      lineHeight: "16px",
    },
    faqHead: {
      fontSize: "16px",
      lineHeight: "24px",
    },
    faqPara: {
      fontSize: "16px",
      lineHeight: "24px",
    },
    kmImage: {
      height: "28px",
    },
    shadowCard: {
      marginBottom: "16px",
    },
    faqDetail: {
      margin: "16px",
    },
    faqLine: {
      margin: "8px 0px",
    },
    circle: {
        bottom:"22px"
    },
    seeAll: {
      bottom: "-8px",
      "& svg": {
        width: "14px",
        height: "14px",
      },
    },
    mtM40: {
      marginTop:"40px"
    },
    mbM40: {
      marginBottom:"40px"
    }
  },

  "@media (max-width: 400px)": {},
  "@media (max-width: 380px)": {
    acrossCity: {
      fontSize: 13,
    },
    ctaTwo: {
      fontSize: 14,
      padding: "4px 8px",
    },
  },
  "@media (max-width: 360px)": {
    carouselContainer: {
      maxWidth: "330px",
    },
  },
}));
export default useStyles;
